import LoginAvatar from "./LoginAvatar";

export default LoginAvatar;
